<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    label-position="top"
    class="server-form"
  >
    <el-form-item
      prop="fileList"
    >
      <!--
      :on-success="handleSuccess"
      -->
      <el-upload
        ref="upload"
        class="upload-demo"
        drag
        action="''"
        :limit="5"
        :http-request="uploadCenterLogoHandle"
        :on-remove="handleRemove"
        :before-upload="beforeAvatarUpload"
        :file-list="form.fileList"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或点击上传</div>
        <div class="el-upload__tip" slot="tip">
          <p>只能导入xls和xlsx文件， <a class="demo-template" :href="url" download target="_blank">下载模板</a></p>
        </div>
        <!--文件名没有显示 todo -->
      </el-upload>
    </el-form-item>
  </el-form>
</template>

<script>
import { uploadFile } from '@/utils/uploadFile'
// 每个实例、每次重置都要新对象。共用一个模块级对象会让 fileList 跨组件实例存活：
// 用户选好文件不点确认就切走，再回来时 el-upload 的 immediate watcher 会把旧文件显示出来，
// 一点确认就把上一份再导一遍
const newForm = () => ({ fileList: [] });
export default {
  name: "importForm",
  data() {
    return {
      url: 'https://alita.oss-cn-shenzhen.aliyuncs.com/image/20260917/a91712c59f964ea384aefe9e764c3716.xlsx',
      form: newForm(),
      rules: {
        fileList: [
          { required: true,message: "请选择文件上传",trigger: 'change'},
        ],
      },
    }
  },
  methods: {
    selfValidate(){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }else {
          console.log('no-pass');
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
      this.clearFiles();
    },
    // el-upload 内部维护自己的 uploadFiles，把 form.fileList 置空动不了它。
    // 不清的话用户"换个文件重传"实际是"两个文件一起传"，上一个文件会被再导一遍。
    clearFiles(){
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      this.form.fileList = [];
    },
    reset(){
      this.form = newForm();
    },
    handleRemove(file){
      this.form.fileList = [];
    },
    handleSuccess(response){
      /*console.log(response);
      // 改为上传fileName,提交到后台的时候处理
      response.data.content[0].name = this.currentFileName;
      this.form.fileList = [response.data.content[0]];
      this.$refs.upload.clearFiles();*/
    },
    // 按扩展名判，与后端一致（它的地址校验也是限 .xls/.xlsx，且实测 POI 真吃老 BIFF 的 .xls）。
    // 原来只放 xlsx 的 MIME，把文案承诺支持的 .xls 挡在门外；file.type 在部分
    // 未注册 MIME 的 Windows 上还会是空串，纯判 MIME 连合法文件一起拒
    beforeAvatarUpload(file) {
      const allowed = /\.(xls|xlsx)$/i.test(file.name);
      if (!allowed) {
        this.$message.error('请上传.xls,.xlsx文件');
      }
      this.currentFileName = file.name;
      return allowed;
    },
    uploadCenterLogoHandle(res){
      // uploadFile 对非 200 已经弹过后端 msg 并 reject，这里把 promise 原样交回 el-upload，
      // 让它把这条文件标成失败；不返回的话这条 rejection 无人接管，on-error 也不会触发
      return uploadFile(res.file).then(rs => {
        this.form.fileList.push({
          name: res.file.name,
          url: rs.data.url,
        });
      })
    },
  },
}
</script>

<style scoped>

</style>
